module.exports = __webpack_public_path__ + "img/mapa_panda.03c24fde.svg";